import React, { useState, useEffect } from "react";
import DataTable from "react-data-table-component";

import Filters from "./Table/Filters";
import columns from "./Table/columns";
import data from "./Table/data";

import ModalTeamList from "./TeamsList/Modal";

import { useCoachPoolContext } from "../../../contexts/CoachPoolContext";
import { useCoachPoolTeamsContext } from "../../../contexts/CoachPoolTeamsContext";

export default function Table() {
  const { dispatch, actions, state } = useCoachPoolContext();
  const {
    dispatch: dispatchCoachPoolTeams,
    actions: actionsCoachPoolTeams,
    state: stateCoachPoolTeams,
  } = useCoachPoolTeamsContext();

  const [keyword, setKeyword] = useState("");

  useEffect(() => {
    actions.loadCoachPools(dispatch);
  }, []);

  return (
    <>
      <Filters keyword={keyword} setKeyword={setKeyword} />
      <div className="datatable-style">
        <DataTable
          title=""
          columns={columns(dispatchCoachPoolTeams, actionsCoachPoolTeams)}
          data={data(state.coachPools, keyword) || []}
          noDataComponent={
            <div className="mt20">
              {state.coachPools == null
                ? "Please, wait ..."
                : "No matching records found"}
            </div>
          }
          persistTableHead={true}
          pagination
          paginationComponentOptions={{
            selectAllRowsItem: true,
            selectAllRowsItemText: "All",
          }}
        />
      </div>
      <ModalTeamList />
    </>
  );
}
